import { HTTP } from "@/helpers/http-common"

const url = "/api/bitacora"

const list = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/list`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const record = (entidades) => new Promise((resolve, reject) => {
  const { entidad, ruta } = entidades;
  HTTP.get(`${url}/record`, { params: { entidad: entidad, ruta: ruta, accion: "Acceso" } }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error.response);
  });
});

export default { list, record }



// WEBPACK FOOTER //
// ./src/services/bitacoras/bitacora/index.js